import { render, staticRenderFns } from "./SelfieCameraAccess.vue?vue&type=template&id=30bf62f1"
import script from "./SelfieCameraAccess.vue?vue&type=script&lang=js"
export * from "./SelfieCameraAccess.vue?vue&type=script&lang=js"
import style0 from "./SelfieCameraAccess.vue?vue&type=style&index=0&id=30bf62f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports